export default {
  getActiveMenu: state => state.activeMenu,
  getMainNavStatus: state => state.mainNavStatus,
  // Track Characteristics
  getTrackStrokeColor: state => state.trackStrokeColor,
  getTrackStrokeWidth: state => state.trackStrokeWidth
}
